import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import bulkSuccessIcon from '../Icons/bulk-success.svg';

const SuccessPageBulkRequest = (props) => {
  return (
    <div className='stepContainer cp-success-page ownership-transfer-step'>
      <Image src={bulkSuccessIcon} />
      <div className='l-title'>התחלנו תהליך של בדיקת המנויים</div>
      <div className='m-title'>
        זמן הטיפול בהעברת בעלות בגורף עלול לקחת זמן. את הסיכום נשלח למייל {props.data.serviceManagerEmail} בסיום התהליך
      </div>

      <div className='continue-button'>
        <BtnSubmit text={isMobile ? 'להעברת קו נוסף' : 'לצפייה בכל העברות הבעלות'} onclick={() => props.nextStepSuccessPage()} />
        <BtnWhiteBlackBorderBigSize text={'לאזור האישי'} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPageBulkRequest);
